class JsonApiDeserializerClass {
    deserializeItems(data, includedEntities) {
        const allData = data.concat(includedEntities).filter(v => v);
        const entityMap = {};
        this.createEntities(allData, entityMap);
        this.connectRelationships(allData, entityMap);
        return data.map(item => this.getEntity(item, entityMap));
    }

    deserializeItem(item, includedEntities) {
        return this.deserializeItems([item], includedEntities)[0];
    }

    createEntities(items, entityMap) {
        for (const item of items) {
            const entity = this.parseSerializedItem(item);
            if (entity) {
                const id = this.createEntityId(item);
                entityMap[id] = entity;
            }
        }
    }

    parseSerializedItem(item) {
        const object = item.attributes;
        object.id = item.id;
        return object;
    }

    connectRelationships(items, entityMap) {
        for (const item of items) {
            if (item.hasOwnProperty('relationships')) {
                Object.keys(item.relationships).forEach((relationshipName) => {
                    const relationship = item.relationships[relationshipName];

                    if (Array.isArray(relationship.data)) {
                        const relatedEntities = [];
                        const relatedIdentifiers = relationship.data;
                        for (const identifier of relatedIdentifiers) {
                            if (this.hasEntity(identifier, entityMap)) {
                                relatedEntities.push(this.getEntity(identifier, entityMap));
                            }
                        }
                        this.setOnEntity(item, entityMap, relationshipName, relatedEntities);
                    } else {
                        if (relationship.data) {
                            const relatedEntity = this.getEntity(relationship.data, entityMap);
                            this.setOnEntity(item, entityMap, relationshipName, relatedEntity);
                        }
                    }

                });
            }
        }
    }

    createEntityId(item) {
        return [item.type, item.id].join('.');
    }

    getEntity(id, entityMap) {
        return entityMap[this.createEntityId(id)];
    }

    hasEntity(id, entityMap) {
        const entityId = this.createEntityId(id);
        return entityMap.hasOwnProperty(entityId) && entityMap[entityId];
    }

    setOnEntity(id, entityMap, property, value) {
        if (this.hasEntity(id, entityMap)) {
            this.getEntity(id, entityMap)[property] = value;
        }
    }
}

let JsonApiDeserializer = new JsonApiDeserializerClass();
export default JsonApiDeserializer;



// WEBPACK FOOTER //
// ./services/JsonApiDeserializer.js